import React, { useState, useContext } from "react";
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

import { DatePicker, TimePicker } from '../components/DatePicker';
import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import { FullWidthTextField } from '../components/FullWidthTextField'
import Time, { Carousel } from '../components/TimePicker';
import { appointmentContext } from '../provider/Times'
import { bookedContext } from '../provider/Booked'
import { API } from 'aws-amplify';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LoadingButton, {} from '../components/LoadingButton';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Typography } from "@material-ui/core";
import Button from '@material-ui/core/Button';

const toDateOptions = { weekday: 'short', month: 'numeric', day: 'numeric', year:'numeric' };

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 2, 1, 2),
    margin: 'auto',
    //marginTop: '150px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: `640px`,
    }
  },
  spacer: {
    width: theme.spacing(1)
  },
  toolbar: theme.mixins.toolbar,
  card: {
    width: '100%'
  },
  datePicker: {
    flexGrow: 1
  },
  header: {
    background: theme.palette.primary.main
  },
  cancelled: {
    background: theme.palette.secondary.main
  },
  actions: {
    padding: theme.spacing(2)
  }
}))

export default function Home() {
  const classes = useStyles();
  const { appointment } = useContext(bookedContext);
  return (<div>
      <div className={classes.toolbar} />
      <div className={classes.root}>
        <AppointmentForm />
      </div>
      {!appointment&&<Carousel elements={Time()} />}
    </div>
  );
}



const AppointmentForm = () => {
  const { select, selected, reload } = useContext(appointmentContext)
  const { appointment, book, cancel, dismiss } = useContext(bookedContext);
  const [ name, setName ] = useState('')
  const [ phone, setPhone ] = useState('')
  const [ email, setMail ] = useState('')
  const [ comment, setComment] = useState('')
  const [ isLoading, setLoading ] = useState('')
  const [ error, setError ] = useState(null)
  const classes = useStyles();

  const date = new Date (selected);
  const dateStr = date.toLocaleDateString('de-DE', toDateOptions);
  const timeStr = date.toLocaleTimeString('de-DE').split (':').slice(0,2).join (':');

  const handleName = (e) => {
    setName (e.target.value);
  }
  const handlePhone = (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]+/, '');
    setPhone (onlyNums);
  }
  const handleComment = (e) => {
    setComment (e.target.value);
  }
  const handleMail = (e) => {
    setMail (e.target.value);
  }
  const handleSubmit =  async (e) => {
    e.preventDefault()
    setLoading (true);

    let res;
    try {
      res = await API.post('appointments', '/appointment', {
        body: {
          name,
          phone,
          email,
          date: selected, 
          from: selected, 
          to: selected + 1000 * 60 * 15,
          comment
        }
      })
      await reload ();
      book (res);
    } catch (e) {
      console.log ("Error", e, e.response)
      setError(e)
      select(null);
      await reload ();
    }
    setLoading (false);
  }

  const dismissBooked = () => {
    dismiss();
  }

  const handleClose = () => {
    setError(null)
  }


  if (appointment) {
    const {name, comment, phone, email, from, id, cancelled} = appointment
    const date = new Date(from);
    return <FormBooked cancel={cancel} cancelled={cancelled} id={id} reload={reload} onDismiss={dismissBooked} phone={phone} name={name} email={email} comment={comment} date={date} />
  }

  return <form onSubmit={handleSubmit}>
      <ErrorDialog open={!!error} message={error&&error.response.data.message} onClose={handleClose} />
      <Card className={classes.card}>
        <CardContent>
          <Grid container justify="space-between" spacing={1}>
            <Grid item xs={12}>
              <TextField fullWidth required value={name} onChange={handleName} label='Name'></TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth required value={phone} onChange={handlePhone} label='Telefonnummer'></TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField type="email" required fullWidth value={email} onChange={handleMail} label='E-Mail'></TextField>
            </Grid>
            {selected&&<Grid item xs={6}>
              <TextField fullWidth className={classes.dateFields} disabled value={dateStr} onChange={handlePhone} label='Datum'></TextField>
            </Grid>}
            {selected&&<Grid item xs={6}>
              <TextField fullWidth className={classes.dateFields} disabled value={timeStr} onChange={handlePhone} label='Uhrzeit'></TextField>
            </Grid>}
           <Grid item xs={12}>
              <TextField 
                fullWidth
                value={comment}
                onChange={handleComment}
                label='Kommentar'
                multiline
                rowsMax="4"
                />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions className={classes.actions}>
          <LoadingButton variant="contained" color="primary" isLoading={isLoading} disabled={!selected || !name || !email || !phone} type="submit">Termin buchen</LoadingButton>
        </CardActions>
      </Card>
  </form> 
}

export const FormBooked = (props) => {
  const classes = useStyles();
  const {name, comment, phone, date, email, onDismiss, reload, id, cancelled, cancel} = props;
  const dateStr = date.toLocaleDateString('de-DE', toDateOptions);
  const timeStr = date.toLocaleTimeString().split (':').slice(0,2).join (':');

  return <Card className={classes.card}>
    <CardHeader 
      className={cancelled?classes.cancelled:classes.header} title={`Ihr Termin wurde erfolgreich ${cancelled?'storniert':'gebucht'}.`}
      action={
        <IconButton onClick={onDismiss}>
          <CloseIcon />
        </IconButton>
      }
    ></CardHeader>
    <CardContent>
      <Grid container justify="space-between" spacing={1}>
        <Grid item xs={12}>
          <TextField fullWidth disabled value={name} label='Name'></TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth disabled value={phone} label='Telefonnummer'></TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth disabled value={email} label='E-Mail'></TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth className={classes.dateFields} disabled value={dateStr} label='Datum'></TextField>
        </Grid>
        <Grid item xs={6}>
              <TextField fullWidth className={classes.dateFields} disabled value={timeStr} label='Uhrzeit'></TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField 
            disabled
            fullWidth
            value={comment}
            label='Kommentar'
            multiline
            rowsMax="4"
            />
        </Grid>
      </Grid>
    </CardContent>
    <CardActions>
      <CancelButton cancelled={cancelled} cancel={cancel} id={id} reload={reload} onDismiss={onDismiss}/>
    </CardActions>
  </Card>
}

const ErrorDialog = (props) => {
  const { open, onClose, message } = props;
  return <Dialog open={open}>
    <DialogTitle>Fehler</DialogTitle>
    <DialogContent><Typography>
      {message}
    </Typography></DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Ok</Button>
    </DialogActions>
  </Dialog>
}
const CancelButton = (props) => {
  const { id, reload, onDismiss, cancel, cancelled} = props
  const [isLoading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading (true);
    const res = await API.post('appointments', `/appointment/${id}/cancel`)
    await reload ();
    cancel()
    setLoading(false);
  }
  
    return <LoadingButton disabled={cancelled} isLoading={isLoading} onClick={onClick} variant={"contained"} color="secondary">{"Stornieren"}</LoadingButton>
}